import { LogoDefault } from './LogoDefault.js';

export const LogoExperiment = (slug) => {
    let src;
    try {
        src = require(`../assets/images/experiments/${slug}.webp`);
    } catch (e) {
        console.log(e);
        src = LogoDefault();
    }
    return src;
}